(() => {
  if (window.WEHomeTop) return;
  const version='home-top-20261023';
  window.WEHomeTop={version};
  const init=() => {
    const header=document.querySelector('[data-we-header]');
    if(!header)return;
    const hero=document.querySelector('[data-we-hero]');
    const isMain=header.dataset.weThemeRole==='main';
    const allowed=()=>{
      try{return isMain&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch{return false;}
    };
    const emit=(action,details={})=>{
      if(!allowed()||typeof window.Shopify?.analytics?.publish!=='function')return false;
      try{
        const result=window.Shopify.analytics.publish('wein:'+action,{version,locale:document.documentElement.lang,...details});
        if(result&&typeof result.catch==='function')result.catch(()=>{});
        return true;
      }catch{return false;}
    };
    document.addEventListener('click',event=>{
      const target=event.target.closest('a,button');if(!target)return;
      if(target.dataset.weHeroAction){emit('hero_select',{destination:target.dataset.weHeroAction});return;}
      const navigation=target.closest('.we-desktop-nav,.we-mobile-nav');
      if(navigation&&target.tagName==='A')emit('header_navigation',{group:target.closest('[data-we-menu-group]')?.dataset.weMenuGroup||'campaign',mode:target.closest('.we-mobile-nav')?'mobile':'desktop'});
    });
    document.addEventListener('toggle',event=>{
      const group=event.target;if(group.matches?.('[data-we-menu-group]')&&group.open)emit('header_menu_open',{group:group.dataset.weMenuGroup});
    },true);
    document.querySelectorAll('[data-we-header-search],#we-search-dialog form').forEach(form=>form.addEventListener('submit',()=>{
      const length=form.querySelector('[name=q]')?.value.trim().length||0;
      if(length)emit('header_search',{query_length:length,mode:form.hasAttribute('data-we-header-search')?'desktop':'dialog'});
    }));
    matchMedia('(min-width:1101px)').addEventListener('change',event=>{
      if(event.matches)document.querySelector('#we-menu-drawer[open]')?.close();
    });
    if(!hero)return;
    let visible=false,viewed=false,timer;
    const sync=()=>{
      clearTimeout(timer);
      if(viewed||!visible||document.visibilityState!=='visible'||document.querySelector('#we-age-gate[open],.we-dialog[open]')||!allowed())return;
      timer=setTimeout(()=>{
        if(visible&&document.visibilityState==='visible'&&!document.querySelector('#we-age-gate[open],.we-dialog[open]'))viewed=emit('hero_view',{placement:'homepage'});
      },800);
    };
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.5;sync();},{threshold:[0,.5]});
    observer.observe(hero);
    document.addEventListener('visitorConsentCollected',sync);
    document.addEventListener('visibilitychange',sync);
    document.querySelectorAll('dialog').forEach(dialog=>new MutationObserver(sync).observe(dialog,{attributes:true,attributeFilter:['open']}));
    if(!window.Shopify?.customerPrivacy&&typeof window.Shopify?.loadFeatures==='function'){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)sync();});
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
